import './cadastro.css';
import api from '../../../services/cle';
import { AxiosError, AxiosResponse } from 'axios';
import React, { useState, useEffect } from 'react';
import { useAppSelector } from '../../../store/hooks';
import { SubmitHandler, useForm } from 'react-hook-form';
import InputLabel from '../../../rxlib/components/input-label';
import Redirecionar from '../../../rxlib/components/redirecionar';
import { Listagem } from '../../../rxlib/components/layout/listagem';
import { ConfiguracoesTabela } from '../../../rxlib/components/table';
import { usuarioTemPermissao } from '../../../rxlib/services/seguranca';
import AcessoBloqueado from '../../../rxlib/components/acesso-bloqueado';
import ButtonsCrud from '../../../rxlib/components/buttons/buttons-crud';
import { RxlibLayout } from '../../../rxlib/components/layout/rxlib-Layout';
import { SelectLabel } from '../../../rxlib/components/select/select-label';
import { ModalWarning } from '../../../rxlib/components/modal/modal-warning';
import HistoricoLicencaOrganizacaoView from '../../historico-licenca-organizacao';
import Breadcrumb, { BreadcrumbItem } from '../../../rxlib/components/breadcrumb';
import ItemLicencaOrganizacaoExclusao from '../../item-licenca-organizacao/exclusao';
import ItemLicencaOrganizacaoCadastro from '../../item-licenca-organizacao/cadastro';
import { formatarDataParaComponente, tratarErroApi } from '../../../rxlib/services/utilitarios';

import {
    ApiError,
    LicencaOrganizacao,
    RequestLicencaOrganizacao,
    ItemLicencaOrganizacaoTemp,
    HistoricoLicencaOrganizacao,
    LicencaOrganizacaoCadastroProps,
    DadosHistoricoLicencaOrganizacao,
    ItemLicencaHistoricoLicencaOrganizacao,
} from '../../../services/tipos';

function LicencaOrganizacaoCadastro(props: LicencaOrganizacaoCadastroProps) {
    const [salvo, setSalvo] = useState<boolean>(false);
    const [showDetail, setShowDetail] = useState<boolean>(false);
    const [carregando, setCarregando] = useState<boolean>(false);
    const [showWarning, setShowWarning] = useState<boolean>(false);
    const [token] = useState(useAppSelector(state => state.token));
    const [messageWarning, setMessageWarning] = useState<string[]>([]);
    const [nomeOrganizacao, setNomeOrganizacao] = useState<string>('');
    const [carregandoDetalhe, setCarregandoDetalhe] = useState<boolean>(false);
    const [showExclusaoDetail, setShowExclusaoDetail] = useState<boolean>(false);
    const [descricaoLicencaBase, setDescricaoLicencaBase] = useState<string>('');
    const [actionDetalhe, setActionDetalhe] = useState(props.match.params.action);
    const [idItemLicencaOrganizacaoTemp, setIdItemLicencaOrganizacaoTemp] = useState<string>('');
    const [dadosHistoricoLicencaOrganizacao, setDadosHistoricoLicencaOrganizacao] = useState<{}>({});
    const [itensLicencaOrganizacaoExcluidos, setItensLicencaOrganizacaoExcluidos] = useState<string[]>([]);
    const [showHistoricoLicencaOrganizacao, setShowHistoricoLicencaOrganizacao] = useState<boolean>(false);

    const [licencaOrganizacao, setLicencaOrganizacao] = useState<LicencaOrganizacao>({
        id: '',
        chave: '',
        status: '',
        descricao: '',
        expiracao: '',
        idOrganizacao: '',
        idLicencaBase: undefined,
    });

    const [dadosLicencaOrganizacao, setDadosLicencaOrganizacao] = useState<LicencaOrganizacao>({
        id: '',
        chave: '',
        status: '',
        descricao: '',
        expiracao: '',
        idOrganizacao: '',
        idLicencaBase: undefined,
    });

    const [itensLicencaOrganizacao, setItensLicencaOrganizacao] = useState<[ItemLicencaOrganizacaoTemp]>([{
        id: '',
        tempId: 0,
        valorItem: '',
        idItemLicenca: '',
        personalizado: true,
        idLicencaOrganizacao: '',
        idItemLicencaBase: undefined,
        itemLicenca: {
            id: '',
            nome: '',
            chave: '',
            tipoControle: '',
        },
    }]);

    const { register, handleSubmit } = useForm<LicencaOrganizacao>();

    const handleHideDetail = () => setShowDetail(false);

    const handleHideWarning = () => setShowWarning(false);

    const handleHideExclusaoDetail = () => setShowExclusaoDetail(false);

    const handleHideHistoricoLicenca = () => setShowHistoricoLicencaOrganizacao(false);

    const breadcrumbs: BreadcrumbItem[] = [
        { texto: 'Home', link: '/home' },
        { texto: 'Organizações e unidades', link: '/organizacao' },
        { texto: 'Licenças da organização', link: `/organizacao/licenca/${props.match.params.idorganizacao}` },
        { texto: props.match.params.action ? 'Visualização' : props.match.params.id ? 'Edição' : 'Novo', link: '' },
    ];

    const itensStatus: any = [
        { id: '', nome: 'Selecione' },
        { id: 1, nome: 'Ativo' },
        { id: 0, nome: 'Inativo' },
    ];

    const configuracoesTabelaDetalhe: ConfiguracoesTabela = {
        mensagemPadrao: 'Não foram encontrados resultados para a consulta.',
        colunas: [
            { nome: 'Nome', campo: 'nome', entidadePai: 'itemLicenca', tipo: 'string' },
            { nome: 'Chave', campo: 'chave', entidadePai: 'itemLicenca', tipo: 'string' },
            { nome: 'Valor', campo: 'valorItem', tipo: 'string' },
        ],
    }

    const temPermissao = props.match.params.action
        ? usuarioTemPermissao(token, 'licenca_organizacao_visualizar')
        : props.match.params.id
            ? usuarioTemPermissao(token, 'licenca_organizacao_editar')
            : usuarioTemPermissao(token, 'licenca_organizacao_novo');

    const podeVisualizarDetalhe = usuarioTemPermissao(token, 'itens_licenca_organizacao_visualizar');
    const podeVisualizarNoDetalhe = podeVisualizarDetalhe ? handleVisualizarDetalhe : undefined;
    const podeNovoDetalhe = !props.match.params.action ? usuarioTemPermissao(token, 'itens_licenca_organizacao_novo') ? handleNovoDetalhe : undefined : undefined;
    const podeEditarDetalhe = !props.match.params.action ? usuarioTemPermissao(token, 'itens_licenca_organizacao_editar') ? handleEditarDetalhe : undefined : undefined;
    const podeExcluirDetalhe = !props.match.params.action ? usuarioTemPermissao(token, 'itens_licenca_organizacao_excluir') ? handleExcluirDetalhe : undefined : undefined;

    useEffect(() => {
        if (temPermissao) {
            if (props.match.params.id) {
                api.get(`/LicencaOrganizacao/${props.match.params.id}`)
                    .then(response => {
                        setLicencaOrganizacao({
                            id: response.data.id,
                            chave: response.data.chave,
                            status: response.data.status,
                            descricao: response.data.descricao,
                            idOrganizacao: response.data.idOrganizacao,
                            idLicencaBase: response.data.idLicencaBase,
                            expiracao: formatarDataParaComponente(response.data.expiracao),
                        });
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error, 'Não foi possível carregar a licença da organização: ');
                    });
            } else {
                setLicencaOrganizacao({
                    id: '',
                    chave: '',
                    status: '',
                    descricao: '',
                    expiracao: '',
                    idOrganizacao: props.match.params.idorganizacao,
                    idLicencaBase: props.match.params.idlicencabase,
                });
            }

            api.get(`/Organizacao/${licencaOrganizacao.idOrganizacao}`)
                .then(response => {
                    setNomeOrganizacao(response.data.nome);
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error, 'Não foi possível carregar a organização: ');
                });

            if (licencaOrganizacao.idLicencaBase) {
                api.get(`/LicencaBase/${licencaOrganizacao.idLicencaBase}`)
                    .then(response => {
                        setDescricaoLicencaBase(response.data.descricao);
                        if (props.match.params.idlicencabase) {
                            setLicencaOrganizacao({
                                id: '',
                                status: '',
                                expiracao: '',
                                chave: response.data.chave,
                                descricao: response.data.descricao,
                                idOrganizacao: props.match.params.idorganizacao,
                                idLicencaBase: props.match.params.idlicencabase,
                            });

                            setCarregandoDetalhe(true);
                            api.get(`/OData/ItemLicencaBase?$expand=itemLicenca&$filter=idLicencaBase eq ${props.match.params.idlicencabase}`)
                                .then(response => {
                                    setTimeout(() => {
                                        let itens: [ItemLicencaOrganizacaoTemp] = getArrayItemLicencaOrganizacaoTemp();
                                        carregarItensLicencaOData(itens, response, false, true);
                                        setItensLicencaOrganizacao(itens);
                                        setCarregandoDetalhe(false);
                                    }, 250);
                                }).catch((error: AxiosError<ApiError>) => {
                                    setCarregandoDetalhe(true);
                                    tratarErro(error, 'Não foi possível carregar os itens da licença base: ');
                                });
                        }
                    }).catch((error: AxiosError<ApiError>) => {
                        tratarErro(error, 'Não foi possível carregar a licença base: ');
                    });
            }
        }
    }, [props.match.params.idorganizacao, props.match.params.idlicencabase, props.match.params.id, licencaOrganizacao.idOrganizacao, licencaOrganizacao.idLicencaBase, temPermissao]);

    useEffect(() => {
        if ((temPermissao) && (podeVisualizarDetalhe)) {
            if (props.match.params.id) {
                setCarregandoDetalhe(true);
                api.get(`/ItemLicencaOrganizacao/PorIdLicencaOrganizacao/${props.match.params.id}`)
                    .then(response => {
                        setTimeout(() => {
                            let itens: [ItemLicencaOrganizacaoTemp] = getArrayItemLicencaOrganizacaoTemp();
                            carregarItensLicenca(itens, response, true, false);
                            setItensLicencaOrganizacao(itens);
                            setCarregandoDetalhe(false);
                        }, 250);
                    }).catch(error => {
                        setCarregandoDetalhe(false);
                        setMessageWarning(tratarErroApi(error, 'Não foi possível realizar a consulta: '));
                        setShowWarning(true);
                    });
            }
        }
    }, [props.match.params.id, temPermissao, podeVisualizarDetalhe]);

    function getArrayItemLicencaOrganizacaoTemp(): [ItemLicencaOrganizacaoTemp] {
        return [{
            id: '',
            tempId: 0,
            valorItem: '',
            idItemLicenca: '',
            personalizado: true,
            idLicencaOrganizacao: '',
            idItemLicencaBase: undefined,
            itemLicenca: {
                id: '',
                nome: '',
                chave: '',
                tipoControle: '',
            },
        }];
    }

    function carregarItensLicencaOData(itens: [ItemLicencaOrganizacaoTemp], response: AxiosResponse, carregarId: boolean, itemBase: boolean) {
        for (let contador = 0; contador < response.data.value.length; contador++) {
            if (contador === 0) {
                itens[0] = {
                    tempId: contador + 1,
                    valorItem: response.data.value[contador].ValorItem,
                    id: (carregarId
                        ? response.data.value[contador].Id
                        : ''),
                    idItemLicenca: response.data.value[contador].IdItemLicenca,
                    personalizado: response.data.value[contador].Personalizado,
                    idLicencaOrganizacao: response.data.value[contador].IdLicencaOrganizacao,
                    idItemLicencaBase: (itemBase
                        ? response.data.value[contador].Id
                        : response.data.value[contador].IdItemLicencaBase),
                    itemLicenca: {
                        id: response.data.value[contador].ItemLicenca.Id,
                        nome: response.data.value[contador].ItemLicenca.Nome,
                        chave: response.data.value[contador].ItemLicenca.Chave,
                        tipoControle: response.data.value[contador].ItemLicenca.TipoControle,
                    },
                };
            } else {
                itens.push({
                    tempId: contador + 1,
                    valorItem: response.data.value[contador].ValorItem,
                    id: (carregarId
                        ? response.data.value[contador].Id
                        : ''),
                    idItemLicenca: response.data.value[contador].IdItemLicenca,
                    personalizado: response.data.value[contador].Personalizado,
                    idLicencaOrganizacao: response.data.value[contador].IdLicencaOrganizacao,
                    idItemLicencaBase: (itemBase
                        ? response.data.value[contador].Id
                        : response.data.value[contador].IdItemLicencaBase),
                    itemLicenca: {
                        id: response.data.value[contador].ItemLicenca.Id,
                        nome: response.data.value[contador].ItemLicenca.Nome,
                        chave: response.data.value[contador].ItemLicenca.Chave,
                        tipoControle: response.data.value[contador].ItemLicenca.TipoControle,
                    },
                });
            }
        }
    }

    function carregarItensLicenca(itens: [ItemLicencaOrganizacaoTemp], response: AxiosResponse, carregarId: boolean, itemBase: boolean) {
        for (let contador = 0; contador < response.data.length; contador++) {
            if (contador === 0) {
                itens[0] = {
                    tempId: contador + 1,
                    valorItem: response.data[contador].valorItem,
                    id: (carregarId
                        ? response.data[contador].id
                        : ''),
                    idItemLicenca: response.data[contador].idItemLicenca,
                    personalizado: response.data[contador].personalizado,
                    idLicencaOrganizacao: response.data[contador].idLicencaOrganizacao,
                    idItemLicencaBase: (itemBase
                        ? response.data[contador].id
                        : response.data[contador].idItemLicencaBase),
                    itemLicenca: {
                        id: response.data[contador].itemLicenca.id,
                        nome: response.data[contador].itemLicenca.nome,
                        chave: response.data[contador].itemLicenca.chave,
                        tipoControle: response.data[contador].itemLicenca.tipoControle,
                    },
                };
            } else {
                itens.push({
                    tempId: contador + 1,
                    valorItem: response.data[contador].valorItem,
                    id: (carregarId
                        ? response.data[contador].id
                        : ''),
                    idItemLicenca: response.data[contador].idItemLicenca,
                    personalizado: response.data[contador].personalizado,
                    idLicencaOrganizacao: response.data[contador].idLicencaOrganizacao,
                    idItemLicencaBase: (itemBase
                        ? response.data[contador].id
                        : response.data[contador].idItemLicencaBase),
                    itemLicenca: {
                        id: response.data[contador].itemLicenca.id,
                        nome: response.data[contador].itemLicenca.nome,
                        chave: response.data[contador].itemLicenca.chave,
                        tipoControle: response.data[contador].itemLicenca.tipoControle,
                    },
                });
            }
        }
    }

    const onSubmit: SubmitHandler<LicencaOrganizacao> = data => {
        setDadosLicencaOrganizacao(data);
        setDadosHistoricoLicencaOrganizacao(getDadosHistoricoLicenca(data));
        if ((itensLicencaOrganizacao.length <= 0) || (itensLicencaOrganizacao[0].tempId <= 0) || (!!!itensLicencaOrganizacao[0].tempId)) {
            setMessageWarning(['Não é possível salvar a licença sem informar ao menos um item.']);
            setShowWarning(true);
        } else {
            setShowHistoricoLicencaOrganizacao(true);
        }
    }

    function handleSalvar(acaoDetalheRealizada: boolean) {
        if (!acaoDetalheRealizada) {
            setSalvo(true);
        }
    }

    function getDadosHistoricoLicenca(data: LicencaOrganizacao): DadosHistoricoLicencaOrganizacao {
        let itens: ItemLicencaHistoricoLicencaOrganizacao[] = [];
        if (itensLicencaOrganizacao.length > 0) {
            for (let contador = 0; contador < itensLicencaOrganizacao.length; contador++) {
                itens.push({
                    id: itensLicencaOrganizacao[contador].id,
                    valorItem: itensLicencaOrganizacao[contador].valorItem,
                    idItemLicenca: itensLicencaOrganizacao[contador].idItemLicenca,
                    idLicencaOrganizacao: itensLicencaOrganizacao[contador].idLicencaOrganizacao,
                });
            }
        }

        return {
            id: data.id,
            chave: data.chave,
            itemLicenca: itens,
            status: data.status,
            expiracao: data.expiracao,
            idOrganizacao: data.idOrganizacao,
        }
    }

    function processarSubmit(historicoLicenca: HistoricoLicencaOrganizacao) {
        setCarregando(true);
        let data: RequestLicencaOrganizacao = {
            id: dadosLicencaOrganizacao.id,
            chave: dadosLicencaOrganizacao.chave,
            descricao: dadosLicencaOrganizacao.descricao,
            expiracao: dadosLicencaOrganizacao.expiracao,
            status: parseInt(dadosLicencaOrganizacao.status),
            idOrganizacao: dadosLicencaOrganizacao.idOrganizacao,
            idLicencaBase: dadosLicencaOrganizacao.idLicencaBase,
        };
        props.match.params.id
            ? editar(data, historicoLicenca)
            : salvar(data, historicoLicenca);
    }

    function salvar(data: RequestLicencaOrganizacao, historicoLicenca: HistoricoLicencaOrganizacao) {
        api.post('/LicencaOrganizacao', data)
            .then(response => {
                historicoLicenca.idLicencaOrganizacao = response.data.id;
                api.post('/HistoricoLicencaOrganizacao', historicoLicenca)
                    .then(response => {
                        let itens: [ItemLicencaOrganizacaoTemp] = [{
                            id: '',
                            tempId: 0,
                            valorItem: '',
                            idItemLicenca: '',
                            personalizado: true,
                            idLicencaOrganizacao: '',
                            idItemLicencaBase: undefined,
                            itemLicenca: {
                                id: '',
                                nome: '',
                                chave: '',
                                tipoControle: '',
                            },
                        }];

                        for (let contador = 0; contador < itensLicencaOrganizacao.length; contador++) {
                            if (contador === 0) {
                                itens[0] = itensLicencaOrganizacao[contador];
                                itens[0].idLicencaOrganizacao = historicoLicenca.idLicencaOrganizacao;
                            } else {
                                itensLicencaOrganizacao[contador].idLicencaOrganizacao = historicoLicenca.idLicencaOrganizacao;
                                itens.push(itensLicencaOrganizacao[contador]);
                            }
                        }

                        setItensLicencaOrganizacao(itens);
                        processarDetalhe();
                    }).catch((error: AxiosError<ApiError>) => {
                        setCarregando(false);
                        tratarErro(error, 'Não foi possível salvar o histórico da licença: ');
                    });
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar a licença da organização: ');
            });
    }

    function editar(data: RequestLicencaOrganizacao, historicoLicenca: HistoricoLicencaOrganizacao) {
        api.put('/LicencaOrganizacao', data)
            .then(response => {
                api.post('/HistoricoLicencaOrganizacao', historicoLicenca)
                    .then(response => {
                        processarDetalhe();
                    }).catch((error: AxiosError<ApiError>) => {
                        setCarregando(false);
                        tratarErro(error, 'Não foi possível salvar o histórico da licença: ');
                    });
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar a licença da organização: ');
            });
    }

    function processarDetalhe() {
        function salvarDetalhe(itemLicenca: ItemLicencaOrganizacaoTemp) {
            if ((itemLicenca.idLicencaOrganizacao !== '') && (itemLicenca.idItemLicenca !== '')) {
                if (!!itemLicenca.id) {
                    editarDetalhe(itemLicenca);
                } else {
                    novoDetalhe(itemLicenca);
                }
            }
        }

        function novoDetalhe(data: ItemLicencaOrganizacaoTemp) {
            api.post('/ItemLicencaOrganizacao', {
                valorItem: data.valorItem,
                idItemLicenca: data.idItemLicenca,
                personalizado: data.personalizado,
                idItemLicencaBase: data.idItemLicencaBase,
                idLicencaOrganizacao: data.idLicencaOrganizacao,
            }).then(response => {
                if (contador < (itensLicencaOrganizacao.length - 1)) {
                    contador++;
                    salvarDetalhe(itensLicencaOrganizacao[contador]);
                }
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar o item da licença: ');
                setCarregando(false);
            });
        }

        function editarDetalhe(data: ItemLicencaOrganizacaoTemp) {
            api.put('/ItemLicencaOrganizacao', {
                id: data.id,
                valorItem: data.valorItem,
                idItemLicenca: data.idItemLicenca,
                personalizado: data.personalizado,
                idItemLicencaBase: data.idItemLicencaBase,
                idLicencaOrganizacao: data.idLicencaOrganizacao,
            }).then(response => {
                if (contador < (itensLicencaOrganizacao.length - 1)) {
                    contador++;
                    salvarDetalhe(itensLicencaOrganizacao[contador]);
                }
            }).catch((error: AxiosError<ApiError>) => {
                tratarErro(error, 'Não foi possível salvar o item da licença: ');
                setCarregando(false);
            });
        }

        function excluirDetalhe(itemLicenca: string) {
            api.delete(`/ItemLicencaOrganizacao/${itemLicenca}`, {})
                .then(response => {
                    if (contador < (itensLicencaOrganizacaoExcluidos.length - 1)) {
                        contador++;
                        excluirDetalhe(itensLicencaOrganizacaoExcluidos[contador]);
                    }
                }).catch((error: AxiosError<ApiError>) => {
                    tratarErro(error, 'Não foi possível excluir o item da licença: ');
                    setCarregando(false);
                });
        }

        let contador: number;
        if (itensLicencaOrganizacao.length > 0) {
            contador = 0;
            salvarDetalhe(itensLicencaOrganizacao[contador]);
        }

        if (itensLicencaOrganizacaoExcluidos.length > 0) {
            contador = 0;
            if (itensLicencaOrganizacaoExcluidos[contador] !== '') {
                excluirDetalhe(itensLicencaOrganizacaoExcluidos[contador]);
            }
        }

        handleSalvar(false);
    }

    function tratarErro(error: AxiosError<ApiError>, mensagem: string) {
        setCarregando(false);
        setMessageWarning(tratarErroApi(error, mensagem));
        setShowWarning(true);
    }

    function handleNovoDetalhe() {
        setActionDetalhe(props.match.params.action);
        setIdItemLicencaOrganizacaoTemp('');
        setTimeout(() => {
            setShowDetail(true);
        }, 50);
    }

    function handleEditarDetalhe(tempId: string) {
        setActionDetalhe(props.match.params.action);
        setIdItemLicencaOrganizacaoTemp(tempId);
        setTimeout(() => {
            setShowDetail(true);
        }, 50);
    }

    function handleExcluirDetalhe(tempId: string) {
        setActionDetalhe(props.match.params.action);
        setIdItemLicencaOrganizacaoTemp(tempId);
        setTimeout(() => {
            setShowExclusaoDetail(true);
        }, 50);
    }

    function handleVisualizarDetalhe(tempId: string) {
        setIdItemLicencaOrganizacaoTemp(tempId);
        setActionDetalhe('view');
        setTimeout(() => {
            setShowDetail(true);
        }, 50);
    }

    function isReadOnly(): boolean {
        return (props.match.params.action === 'view')
            ? true
            : (licencaOrganizacao.idLicencaBase)
                ? true
                : false;
    }

    return (
        <>
            <RxlibLayout>
                <Breadcrumb
                    itens={breadcrumbs} />
                <form onSubmit={handleSubmit(onSubmit)} className='rxlib-form'>
                    <div className='container-fluid'>
                        <div className='row px-1'>
                            <div className='col-12'>
                                <h6>{props.match.params.action ? 'Visualizar' : props.match.params.id ? 'Editar' : 'Nova'} licença da organização</h6>
                            </div>
                        </div>
                        {
                            props.match.params.id
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <InputLabel
                                            name='id'
                                            type='text'
                                            id='inputId'
                                            maxLength={50}
                                            readOnly={true}
                                            label='Código:'
                                            autoFocus={false}
                                            defaultValue={licencaOrganizacao.id}
                                            referencia={register({ required: true })}
                                            placeholder='Código da licença da organização'
                                            className='rxlib-input-label-linha-item-licenca' />
                                    </div>
                                </div>
                                : ''
                        }
                        <div className='row px-1 d-none'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    readOnly={true}
                                    autoFocus={false}
                                    name='idOrganizacao'
                                    label='idOrganizacao:'
                                    id='inputIdOrganizacao'
                                    placeholder='idOrganizacao'
                                    referencia={register({ required: true })}
                                    defaultValue={licencaOrganizacao.idOrganizacao}
                                    className='rxlib-input-label-linha-item-licenca' />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    readOnly={true}
                                    autoFocus={false}
                                    name='organizacao'
                                    label='Organização:'
                                    id='inputOrganizacao'
                                    placeholder='Organização'
                                    defaultValue={nomeOrganizacao}
                                    referencia={React.createRef()}
                                    className='rxlib-input-label-linha-item-licenca' />
                            </div>
                        </div>
                        {
                            licencaOrganizacao.idLicencaBase
                                ? <div className='row px-1 d-none'>
                                    <div className='col-12 mt-1'>
                                        <InputLabel
                                            type='text'
                                            maxLength={50}
                                            readOnly={true}
                                            autoFocus={false}
                                            name='idLicencaBase'
                                            label='idLicencaBase:'
                                            id='inputIdLicencaBase'
                                            placeholder='idLicencaBase'
                                            referencia={register({ required: false })}
                                            defaultValue={licencaOrganizacao.idLicencaBase}
                                            className='rxlib-input-label-linha-item-licenca' />
                                    </div>
                                </div>
                                : ''
                        }
                        {
                            licencaOrganizacao.idLicencaBase
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <InputLabel
                                            type='text'
                                            maxLength={50}
                                            readOnly={true}
                                            autoFocus={false}
                                            name='licencabase'
                                            label='Licença base:'
                                            id='inputLicencaBase'
                                            placeholder='Licença base'
                                            referencia={React.createRef()}
                                            defaultValue={descricaoLicencaBase}
                                            className='rxlib-input-label-linha-item-licenca' />
                                    </div>
                                </div>
                                : ''
                        }
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    maxLength={50}
                                    autoFocus={true}
                                    name='descricao'
                                    label='Descrição:'
                                    id='inputDescricao'
                                    placeholder='Descrição'
                                    readOnly={isReadOnly()}
                                    referencia={register({ required: true })}
                                    defaultValue={licencaOrganizacao.descricao}
                                    className='rxlib-input-label-linha-item-licenca' />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='text'
                                    name='chave'
                                    label='Chave:'
                                    maxLength={50}
                                    id='inputChave'
                                    autoFocus={false}
                                    placeholder='Chave'
                                    readOnly={isReadOnly()}
                                    defaultValue={licencaOrganizacao.chave}
                                    referencia={register({ required: true })}
                                    className='rxlib-input-label-linha-item-licenca' />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <InputLabel
                                    type='date'
                                    maxLength={10}
                                    name='expiracao'
                                    autoFocus={false}
                                    label='Expiração:'
                                    id='inputExpiracao'
                                    placeholder='  /  /    '
                                    referencia={register({ required: true })}
                                    defaultValue={licencaOrganizacao.expiracao}
                                    readOnly={props.match.params.action === 'view'}
                                    className='rxlib-input-label-linha-item-licenca' />
                            </div>
                        </div>
                        <div className='row px-1'>
                            <div className='col-12 mt-1'>
                                <SelectLabel
                                    foco='nao'
                                    name='status'
                                    label='Status:'
                                    id='inputStatus'
                                    ariaLabel='status'
                                    itens={itensStatus}
                                    campoExibicaoRegistro='nome'
                                    campoIdentificadorRegistro='id'
                                    action={props.match.params.action}
                                    referencia={register({ required: true })}
                                    valorSelecionado={licencaOrganizacao.status}
                                    className='rxlib-input-label-linha-item-licenca' />
                            </div>
                        </div>
                        {
                            podeVisualizarDetalhe
                                ? <div className='row px-1'>
                                    <div className='col-12 mt-1'>
                                        <Listagem
                                            campoId='tempId'
                                            listagemDetalhe={true}
                                            tipoBotaoAcao='button'
                                            onNovo={podeNovoDetalhe}
                                            descricao='Itens da licença'
                                            onEditar={podeEditarDetalhe}
                                            carregando={carregandoDetalhe}
                                            onExcluir={podeExcluirDetalhe}
                                            fonteDados={itensLicencaOrganizacao}
                                            onVisualizar={podeVisualizarNoDetalhe}
                                            className='rxlib-listagem-detalhe-item-licenca'
                                            configuracoesTabela={configuracoesTabelaDetalhe}
                                            idEntidadePai={licencaOrganizacao.id ? licencaOrganizacao.id : '0'} />
                                    </div>
                                </div>
                                : ''
                        }
                        <ButtonsCrud
                            carregando={carregando}
                            styleButton='btn-rxlib'
                            visualizar={props.match.params.action === 'view'}
                            linkCancelarVoltar={`/organizacao/licenca/${licencaOrganizacao.idOrganizacao}`} />
                    </div>
                </form>
                <ModalWarning
                    show={showWarning}
                    message={messageWarning}
                    onHide={handleHideWarning} />
                <ItemLicencaOrganizacaoCadastro
                    show={showDetail}
                    tratarErro={tratarErro}
                    onSalvar={handleSalvar}
                    onHide={handleHideDetail}
                    readOnly={actionDetalhe === 'view'}
                    fonteDados={itensLicencaOrganizacao}
                    setFonteDados={setItensLicencaOrganizacao}
                    idLicencaOrganizacao={licencaOrganizacao.id}
                    idItemLicencaOrganizacaoTemp={idItemLicencaOrganizacaoTemp} />
                <ItemLicencaOrganizacaoExclusao
                    tratarErro={tratarErro}
                    onExcluir={handleSalvar}
                    show={showExclusaoDetail}
                    onHide={handleHideExclusaoDetail}
                    fonteDados={itensLicencaOrganizacao}
                    setFonteDados={setItensLicencaOrganizacao}
                    fonteDadosExcluidos={itensLicencaOrganizacaoExcluidos}
                    idItemLicencaOrganizacaoTemp={idItemLicencaOrganizacaoTemp}
                    setFonteDadosExcluidos={setItensLicencaOrganizacaoExcluidos} />
                <HistoricoLicencaOrganizacaoView
                    onSubmitForm={processarSubmit}
                    onHide={handleHideHistoricoLicenca}
                    show={showHistoricoLicencaOrganizacao}
                    idLicencaOrganizacao={licencaOrganizacao.id}
                    dadosHistoricoLicencaOrganizacao={dadosHistoricoLicencaOrganizacao} />
                <AcessoBloqueado
                    permissao={temPermissao} />
                <Redirecionar
                    se={salvo}
                    para={`/organizacao/licenca/${licencaOrganizacao.idOrganizacao}`} />
            </RxlibLayout>
        </>
    );
}

export default LicencaOrganizacaoCadastro;